/**
 * 微信环境检测工具函数
 */

// 检测是否为微信环境
export function isWechat() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) === "micromessenger";
}

// 检测是否为微信小程序环境
export function isMiniProgram() {
  return new Promise((resolve) => {
    if (!isWechat()) {
      resolve(false);
      return;
    }
    
    // 如果有微信JS-SDK，使用官方方法检测
    if (window.wx && window.wx.miniProgram) {
      window.wx.miniProgram.getEnv((res) => {
        resolve(res.miniprogram);
      });
    } else {
      // 降级检测方法
      resolve(false);
    }
  });
}

// 获取微信版本号
export function getWechatVersion() {
  if (!isWechat()) {
    return null;
  }
  
  const ua = navigator.userAgent;
  const wechatInfo = ua.match(/MicroMessenger\/([\d\.]+)/i);
  return wechatInfo ? wechatInfo[1] : null;
}

// 比较版本号
export function compareVersion(v1, v2) {
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);

  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }

  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);

    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}

// 检查微信版本是否满足要求
export function checkWechatVersion(requiredVersion = '8.0.8') {
  if (!isWechat()) {
    return { isWechat: false, versionOk: true, message: '非微信环境，跳过版本检查' };
  }
  
  const currentVersion = getWechatVersion();
  if (!currentVersion) {
    return { isWechat: true, versionOk: false, message: '无法获取微信版本信息' };
  }
  
  const versionCompare = compareVersion(currentVersion, requiredVersion);
  const versionOk = versionCompare >= 0;
  
  return {
    isWechat: true,
    versionOk,
    currentVersion,
    requiredVersion,
    message: versionOk ? '微信版本满足要求' : `仅支持微信${requiredVersion}以上版本，请升级微信版本`
  };
}

// 安全的微信分享初始化（非微信环境不执行）
export function safeWechatShare(shareConfig, callback) {
  if (!isWechat()) {
    console.log('非微信环境，跳过微信分享初始化');
    if (callback) callback({ success: false, message: '非微信环境' });
    return;
  }
  
  // 执行原有的微信分享逻辑
  if (callback) callback({ success: true, message: '微信环境，可以执行分享' });
}